module.exports = __webpack_public_path__ + "fonts/Raleway-ExtraBoldItalic.db1ef2f9.ttf";